export const LOADING_PLACEHOLDER_LIST_ITEM_COUNT_MOBILE = 6;
export const LOADING_PLACEHOLDER_LIST_ITEM_COUNT_DESKTOP = 12;

export const NO_SEARCH_RESULT_TITLE = 'No results found';
export const NO_SEARCH_RESULT_MESSAGE = 'Sorry, there are no search results for your following query. Please refine your search fields.\n'; // @suppress longLineCheck

export const SELECT_MENU_CLOSE_DELAY_MSEC = 1;

export const RESULT_PER_PAGE_NUM_LIMIT = 15;

export const NEW_CARS_COMPARE_LIST_LOCAL_STORAGE_KEY = 'newCarsCompareList';

export const NUM_COMPARISON_MAX_VEHICLES = 4;
